import React, { useState } from 'react';
// @ts-ignore
import styles from './../MonitoringCenterList/MonitoringCenterListItem.module.scss';
import FormattedDate, {
	FormattedDateTime,
} from '../../../../Components/FormattedDate';
import TreatmentModal from '../../../../Components/Treatment/TreatmentModal';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import { showCaseDetail } from '../../../Case/Services/case.service';
import { useAppContext } from '../../../../Services/AppContext';
import OverlayLoading from '../../../../Components/OverlayLoading';
import Button from '../../../../Components/Button/Button';
import { useReAssignCaseMutation } from '../../../../graphql/graphql';
import useApiClient from '../../../Base/Hooks/useApiClient';
import { IMonitoringCenterListItem } from '../MonitoringCenterList/MonitoringCenterListItem';
import CaseMedicalReportButtonList from '../../../Case/Components/CaseMedicalReportButtonList/CaseMedicalReportButtonList';
import { Backlink } from '../../../Base/Enums/Backlink.enum';
import Tooltip from '../../../../Components/Popup/Tooltip';

interface Props {
	item: IMonitoringCenterListItem;
	workplaceMemberId?: string;
}

const MonitoringCenterListItem: React.FC<Props> = ({
	item,
	workplaceMemberId,
}) => {
	const [isTreatmentOpen, setIsTreatmentOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const { workplaceId } = useAppContext();
	const [reAssignCase] = useReAssignCaseMutation();
	const { displayError } = useApiClient();

	const handleConnectWithPatient = async (caseId: string) => {
		if (workplaceMemberId) {
			setIsLoading(true);
			try {
				await reAssignCase({
					caseId,
					workplaceId,
					workplaceMemberId,
				}).unwrap();
				await showCaseDetail(caseId, Backlink.MONITORING_CENTER);
			} catch (e) {
				displayError(e);
			} finally {
				setIsLoading(false);
			}
		}
	};

	return (
		<>
			{isLoading && <OverlayLoading />}
			<tr className={styles.wrapper}>
				<td>{item.number}</td>
				<td className={styles.boldItem}>{item.caseType}</td>
				<td>
					<LinkButton
						title={item.patient.fullName}
						theme={Theme.BLUE}
						className={styles.patientButton}
						onClick={() => setIsTreatmentOpen(true)}
					/>
				</td>
				<td>{item.patient.birthNumber}</td>
				<td className={styles.boldItem}>
					{item.patient.attendingDoctor.fullName}
				</td>
				<td>
					{item.assignedDoctor?.shortedName && (
						<Tooltip trigger={item.assignedDoctor.shortedName}>
							{item.assignedDoctor.fullName}
						</Tooltip>
					)}
				</td>
				<td>{item.workplace.shortcut}</td>
				<td>{item.diagnosis?.title}</td>
				<td>
					{item.medicalReports?.length && (
						<CaseMedicalReportButtonList
							items={item.medicalReports}
							patientId={item.patient.id}
						/>
					)}
				</td>
				<td>
					{item.createdAt && <FormattedDateTime datetime={item.createdAt} />}
				</td>
				<td>
					{item.lastChangeAt && (
						<FormattedDateTime datetime={item.lastChangeAt} />
					)}
				</td>
				<td>
					<Button
						title='base.shared.reconnectWithThePatient'
						theme={Theme.GREEN}
						onClick={() => handleConnectWithPatient(item.id)}
						small
					/>
				</td>
			</tr>
			{isTreatmentOpen && (
				<TreatmentModal
					opened={isTreatmentOpen}
					patientId={item.patient.id}
					onClose={() => setIsTreatmentOpen(false)}
				/>
			)}
		</>
	);
};

export default MonitoringCenterListItem;
